import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IDismissChallengeIssueRequest } from './dismiss-challenge-issue-request';
import type { IDismissChallengeIssueResponse } from './dismiss-challenge-issue-response';
import { dismissChallengeIssueResponseSchema } from './dismiss-challenge-issue-response';

export async function dismissChallengeIssueApi({
  issueId,
  note,
}: IDismissChallengeIssueRequest): Promise<IValidatedResponse<IDismissChallengeIssueResponse>> {
  return postRequest<IDismissChallengeIssueResponse>({
    path: `/sys/challenge-issues/${issueId}/dismiss/v1`,
    body: { note },
    schema: dismissChallengeIssueResponseSchema,
  });
}
